import withResponsive from '../hoc/withResponsive'
import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'swiper-keynumbers',

  componentDidMount () {
    setTimeout(() => {
      this.swiper = new Swiper(this.el, {
        // Optional parameters
        direction: 'horizontal',
        speed: 600,
        // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
        // reverseDirection: true,
        loop: false,
        // loopedSlides: 5,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-home-keynumbers-button-next',
          prevEl: '.swiper-home-keynumbers-button-prev',
        },
        pagination: {
          el: '.swiper-home-keynumbers-pagination',
          type: 'bullets',
          bulletElement: 'li',
        },
        slidesPerView: 1,
        spaceBetween: 0,
        // slidesOffsetBefore: 0,

        /*  autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        }, */

        /* on: {
          slideChangeTransitionEnd: function () {
            that.updateCounter(this.realIndex)
            that.animate(true)
          },

          slideChangeTransitionStart: function () {
            that.animate(false)
          }
        },, */
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 768px
          769: {
            slidesPerView: 'auto',
            spaceBetween: 180,
          },
        },
      })

      this.margin = window.innerWidth > 768 ? 180 : 0
      this.wrapperW =
        this.swiper.slides.length * this.swiper.slides[0].offsetWidth +
        (this.swiper.slides.length - 1) * this.margin // this.swiper.wrapperEl.offsetWidth
      this.wrapperH = this.swiper.wrapperEl.offsetHeight

      this.initWave()

      // this.svg.style.marginLeft = this.swiper.slides[0].offsetWidth/4 +'px'

      this.buildWave(
        this.wrapperW /* / this.swiper.slides.length */,
        this.wrapperH
      )
    }, 300)
  },

  initWave () {
    this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    this.svg.setAttribute('width', this.wrapperW)
    this.svg.setAttribute('height', this.wrapperH)
    /* this.path = document. createElementNS("http://www.w3.org/2000/svg", "line");
    this.path.setAttribute("fill", 'none' );
    this.path.setAttribute("stroke", "#FF0000" );
    this.path.setAttribute("stroke-width", '1');
    this.svg.appendChild ( this.path ); */
    this.swiper.wrapperEl.appendChild(this.svg)
  },

  buildWave (pW, pH) {
    /*
     console.log(w, h)
     const w = pW
     const h = pH
     const amplitude = 1 // 0.25 // 1/4 de la hauteur
     var m = 0.512286623256592433;
     var m = .8;

    var pathData = [
      'M', 0, h * 1, // 0.625,
      'c',  amplitude * h * m, 0,
      amplitude * h * (1 - m), - amplitude * h,
      amplitude * h, - amplitude * h,
      's', amplitude * h * (1 - m), amplitude * h,
      amplitude * h, amplitude * h,
      's', amplitude * h * (1 - m), - amplitude * h,
      amplitude * h, - amplitude * h,
      's', amplitude * h * (1 - m), amplitude * h,
      amplitude * h, amplitude * h,
      's', amplitude * h * (1 - m), - amplitude * h,
      amplitude * h, - amplitude * h,
      's', amplitude * h * (1 - m), amplitude * h,
      amplitude * h, amplitude * h,
      's', amplitude * h * (1 - m), - amplitude * h,
      amplitude * h, - amplitude * h
    ].join(' ');

    this.path.setAttribute('d', pathData); */

    var svg = this.svg
    var origin = {
      // origin of axes
      x: -this.swiper.slides[0].offsetWidth / 2,
      y: pH / 2,
    }
    var amplitude = -(pH / 2 - 19 - 11) // wave amplitude
    var rarity = this.swiper.slides.length // point spacing
    var freq = this.swiper.slides.length * 0.0093 // 0.037 // angular frequency
    var phase = 0.1 // phase angle

    for (var i = -100; i < 1000; i++) {
      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line')

      line.setAttribute('x1', (i - 1) * rarity + origin.x)
      line.setAttribute(
        'y1',
        Math.sin(freq * (i - 1 + phase)) * amplitude + origin.y
      )

      line.setAttribute('x2', i * rarity + origin.x)
      line.setAttribute(
        'y2',
        Math.sin(freq * (i + phase)) * amplitude + origin.y
      )

      svg.appendChild(line)
    }
  },
})
